export default {
	title: 'Portfolio',
	description: 'All my Gerositus projects',
	actions: {
		back_to_this: 'Back to portfolio'
	},
	search_projects: 'Search projects',
	cta: {
		welcome:
			'Welcome and thank you for connecting to Gerositus Strategy Suite!',
		subscribe: 'Subscribe now',
		create_permission: 'to be able to create new projects.'
	},
	tabs: {
		risks: {
			title: 'Risks and opportunities settings'
		}
	},
	ownership: {
		all: 'All',
		owner: 'Owner',
		reader: 'Reader'
	}
};
